import { createContext, useContext } from 'react';

/**
 * What a page may put into the app shell around it: a slot after the
 * breadcrumb for a control that refines the current page (the documents
 * page's result switcher) and a slot at the header's end for the page's own
 * actions (an open result's Extract and Export). The shell owns both; pages
 * only portal into them.
 *
 * Whether a page fills the main region edge to edge is not a page request:
 * the shell reads it from the URL (`isTemplateResultLocation`), so the edges
 * and the folded sidebar are right in the first frame, before the page loads.
 */
export interface PageChromeContextValue {
  /** The header element a page's breadcrumb tail portals into; `null` until mounted. */
  readonly breadcrumbTail: HTMLElement | null;
  /** The header element a page's actions portal into; `null` until mounted. */
  readonly pageActions: HTMLElement | null;
  /** True while a page fills the tail; the page's own crumb then links back to its base view. */
  readonly breadcrumbTailInUse: boolean;
  readonly setBreadcrumbTailInUse: (inUse: boolean) => void;
}

export const PageChromeCtx = createContext<PageChromeContextValue | null>(null);

export function usePageChrome(): PageChromeContextValue | null {
  return useContext(PageChromeCtx);
}
